/**
 * Returns a string array of supported social providers
 * @returns
 */

export const getSocialProviders = () => {
  return ['Facebook', 'Google', 'Github', 'Skolon', 'Feide', 'SignInWithApple'];
};
